import { twMerge } from 'tailwind-merge';

export const tailwindMerge = twMerge;
